import ProfileService from '@/service/profile'
export default {
  getProfile ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ProfileService.getProfile().then(res => {
        commit('getProfile', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  changePassword ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ProfileService.changePassword(payload.password).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateProfile ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ProfileService.updateProfile(payload.user).then(res => {
        commit('getProfile', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  addTotalNotification ({commit}, payload) {
    commit('addTotalNotification')
  },

  cleanTotalNotification ({commit}, payload) {
    commit('cleanTotalNotification')
  }
}



// WEBPACK FOOTER //
// ./src/store/module/profile/actions.js